import React from "react";
import { Datagrid, List, TextField, useLocaleState } from "react-admin";

const BannersList = () => {
  const [locale] = useLocaleState();

  return (
    <List pagination={false}>
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField label="banners.title" source={`bannerTitle.${locale}`} />
      </Datagrid>
    </List>
  );
};

export default BannersList;
